import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string | Date, format: string = 'YYYY-MM-DD HH:mm'): string {
    if (!value) {
      return '';
    }

    const localDate = moment.utc(value).local();

    return localDate.format(format);
  }
}
